<template>
  <PageBreadcrumb
    :crumbs="[
      {
        label: 'Gestione Accreditati',
      },
    ]"
  />
  <div class="flex justify-between mb-4">
    <div class="flex-grow">
      <SearchInput v-model="search" />
    </div>
    <div class="self-end">
      <ActionButton
        v-if="authStore.canManageUser"
        @click="router.push('/accreditati/crea')"
      >
        <PlusCircleIcon class="w-5 h-5 inline-block" />
        Crea nuova accreditato
      </ActionButton>
    </div>
  </div>

  <DataTable :data="data">
    <template #heading>
      <tr>
        <SortableColumn
          v-model="sortStatus"
          name="name"
        >
          Nome
        </SortableColumn>
        <th class="text-right p-2" />
      </tr>
    </template>
    <template #body>
      <tr
        v-for="affiliate in data"
        :key="'affilate-table-' + affiliate.uuid"
        class="odd:bg-gray-100"
        :class="{ 'text-gray-300': affiliate.disabled }"
      >
        <td class="p-2">
          {{ affiliate.name }}
        </td>
        <td
          class="p-2 text-right"
          :class="{ 'text-corepla-text': affiliate.disabled }"
        >
          <RouterLink
            v-if="authStore.canManageUser"
            title="Modifica Accreditato"
            :to="'/accreditati/' + affiliate.uuid"
          >
            <PencilSquareIcon class="h-5 w-5 inline-block mx-1" />
          </RouterLink>
          <RouterLink
            v-if="authStore.isAdmin"
            title="Guarda partecipanti"
            :to="'/partecipanti?affiliateUuid' + affiliate.uuid"
          >
            <HomeModernIcon class="h-5 w-5 inline-block mx-1" />
          </RouterLink>
          <a
            v-if="!affiliate.disabled && authStore.canManageUser"
            href="#"
            title="Blocca Accreditato"
            @click.prevent="block(affiliate)"
          >
            <PauseCircleIcon class="h-5 w-5 inline-block mx-1" />
          </a>
          <a
            v-if="affiliate.disabled && authStore.canManageUser"
            href="#"
            title="Ripristina Accreditato"
            @click.prevent="unblock(affiliate)"
          >
            <PlayCircleIcon class="h-5 w-5 inline-block mx-1" />
          </a>
          <a
            href="#"
            title="Elimina Accreditato"
            @click.prevent="destroy(affiliate)"
          >
            <TrashIcon class="h-5 w-5 inline-block mx-1" />
          </a>
        </td>
      </tr>
    </template>
  </DataTable>

  <DataTablePaginator
    :count="count"
    :count-all="countAll"
    :count-filtered="countFiltered"
    :current-page="currentPage"
    :has-next="hasNext"
    :has-prev="hasPrev"
    :next="next"
    :prev="prev"
    :total-pages="totalPages"
  />
</template>

<script setup>
import {
  HomeModernIcon,
  PauseCircleIcon,
  PencilSquareIcon,
  PlayCircleIcon,
  PlusCircleIcon,
  TrashIcon} from "@heroicons/vue/24/outline";
import { ref, watch } from "vue";
import { useRouter } from "vue-router";

import ActionButton from "@/components/ActionButton.vue";
import DataTable from "@/components/list/DataTable.vue";
import DataTablePaginator from "@/components/list/DataTablePaginator.vue";
import SearchInput from "@/components/list/SearchInput.vue";
import SortableColumn from "@/components/list/SortableColumn.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useDataTable from "@/composables/datatable.js";
import { useAuthStore } from "@/stores/auth";

const router = useRouter();
const authStore = useAuthStore();

const search = ref("");
const disabledStatus = ref(null);

const sortStatus = ref(["name", -1]);

const {
  data,
  count,
  countFiltered,
  countAll,
  currentPage,
  totalPages,
  next,
  prev,
  hasPrev,
  hasNext,
  doFilter,
  action,
} = await useDataTable({
  endpoint: "/affiliate/list",
  sortStatus,
  search,
  searchProperties: ["name"],
});

watch(disabledStatus, () => {
  doFilter();
});

const destroy = (auction) => {
  action(
    "delete",
    "affiliate/" + auction.uuid,
    "Accreditato eliminato con successo"
  );
};

const block = (user) => {
  action(
    "put",
    "affiliate/block/" + user.uuid,
    "Accreditato bloccato con successo"
  );
};

const unblock = (user) => {
  action(
    "put",
    "affiliate/unblock/" + user.uuid,
    "Accreditato ripristinato con successo"
  );
};
</script>
